import { datadogLogs } from '@datadog/browser-logs';
import { MessagePayload, NotificationPayload } from '@firebase/messaging';

export function logNotificationReceived(
  payload: NotificationPayload | MessagePayload,
  context: 'background' | 'foreground'
) {
  datadogLogs.logger.info('Notification received', {
    payload,
    context,
  });
}

export function logNotificationClick(event: NotificationEvent) {
  const notification = event.notification;
  if (notification) {
    datadogLogs.logger.info('Notification clicked', {
      notification,
    });
  }
}

type ToastType = 'FARE_ASSIGNED' | 'FARE_UPDATED';

export function logToastClick(toastType: ToastType, fareId?: string, notificationId?: string) {
  datadogLogs.logger.info('Toast clicked', {
    toastType,
    fareId,
    notificationId,
  });
}
